<template>
    <div class="home">
        <div v-if="mskShow" class="msk"></div>
        <div class="header">
            <div class="head" :class="$iosHeight()">
                <div class="district">{{ area }}</div>
                <div class="search">
                    <span class="search-icon"></span>
                    <input type="text" @click="onSearch" value="请输入搜索关键词" readonly>
                </div>
            </div>
            <div class="heightDiv" :class="$iosHeightDiv2()"></div>
            <div class="tabNav">
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-tabs v-model="tabVal" @click="onTabClick" line-width='40px'>
                        <van-tab v-for="(item, index) in carData" :key="index" :name="index" :title="item.name">
                            <div class="contain" v-if="index === 0 && userInfo.belongMerchantCode">
                                <Recommend ref="recommend"></Recommend>
                            </div>
                            <div class="contain" v-else>
                                <System :ref="`good${index}`" :tab="tabVal" :item="item"></System>
                            </div>
                        </van-tab>
                    </van-tabs>
                </van-pull-refresh>
            </div>
        </div>
        <Footer :menus="menus"></Footer>
        <Super></Super>
        <CustomerService />
    </div>
</template>
<script>
import Recommend from './common/recommend'
import System from './common/systemList'
import Footer from '../../common/footer'
import Super from './common/supernatant'
import CustomerService from '../common/customerService'
import { getCompanyDetail } from '../api/api'
import { newCache } from '@/utils/index'
import { mapActions } from 'vuex'
export default {
    name: 'home',
    components: {
        Recommend,
        System,
        Footer,
        Super,
        CustomerService
    },
    data () {
        return {
            menus: 1,
            mskShow: false,
            userInfo: '',
            area: '全国',
            tabVal: 0,
            height: '',
            carData: [],
            merchantCode: '',
            memberCode: '',
            isLoading: false,
            recommendShow: true
        }
    },
    methods: {
        ...mapActions(['findCategoryListData', 'getUserInfoData']),
        onSearch () {
            localStorage.setItem('searchBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/search/index' })
        },
        onTabClick () {
            if (!this.tabVal) {
                this.$refs.recommend[0].getShow() // 解决swiper显示隐藏width丢失的问题
            }
            localStorage.setItem('tab', this.tabVal)
        },
        onEffect () {
            this.$router.push({ path: '/b2b/home/effectList' })
        },
        onRefresh () {
            setTimeout(() => {
                if (!this.tabVal) {
                    this.findIndexCategoryList(0)
                    this.$refs.recommend[0].init()
                } else {
                    const refName = `good${this.tabVal}`
                    this.$refs[refName][0].init()
                }
                this.isLoading = false
            }, 1000)
        },
        findIndexCategoryList (tabVal) {
            this.findCategoryListData({
                merchantCode: this.userInfo.belongMerchantCode,
                memberCode: this.userInfo.companyCode
            }).then((data) => {
                let temp = []
                if (this.userInfo.belongMerchantCode) {
                    temp = [
                        {
                            id: Date.now(),
                            name: '推荐'
                        }
                    ]
                } else {
                    temp = []
                }
                this.carData = temp.concat(data)
                this.$nextTick(() => {
                    this.tabVal = tabVal
                })
            })
        },
        async getCompanyData () {
            let areaInfo = localStorage.getItem('areaInfo') ? JSON.parse(localStorage.getItem('areaInfo')) : ''
            if (!areaInfo) {
                const { data } = await getCompanyDetail({
                    companyCode: this.userInfo.companyCode
                })
                areaInfo = data
                localStorage.setItem('areaInfo', JSON.stringify(data))
            }
            if (areaInfo && areaInfo.cityName) {
                this.area = areaInfo.cityName.substring(0, 5)
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        newCache('home')
        next()
    },
    beforeRouteLeave (to, from, next) {
        this.$route.meta.savedPosition = window.scrollY
        next()
    },
    async activated () {
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
        // 刷新局部的几个接口
        if (this.$route.meta.isUseCache) {
            this.findIndexCategoryList(0)
            this.$refs.recommend[0].getSpick(2)
            this.$refs.recommend[0].getSpick()
            this.$refs.recommend[0].getPresell()
            this.$refs.recommend[0].groupGo()
            this.$route.meta.isUseCache = false
        }
        // 刷新整个首页
        if (this.$route.meta.isPage) {
            await this.getUserInfoData()
            this.findIndexCategoryList(0)
            this.$refs.recommend[0].init()
            this.$route.meta.isPage = false
        }
    },
    async mounted () {
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
        let tabVal = localStorage.getItem('tab') ? parseInt(localStorage.getItem('tab')) : 0
        // 大B端预览的时候传递的参数，当有这个参数，就只显示推荐页面
        let typeShow = this.$route.query.type ? this.$route.query.type : ''
        if (!typeShow) {
            // 获取头部的推荐类目
            this.findIndexCategoryList(tabVal)
        } else {
            this.data = this.userInfo.belongMerchantCode ? [{ 'id': 1, 'categoryName': '推荐' }] : []
            this.mskShow = true
        }
        // 获取公司信息，用于展示搜索框旁边的所属区域
        this.getCompanyData()
    }
}
</script>
<style lang="scss" scoped>
.home {
    position: relative;
    background: #ffffff;
    .head {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        padding: 16px 24px 8px 24px;
        z-index: 999;
        background-color: #fff;
        display: flex;
        justify-self: start;
        .district {
            padding-right: 20px;
            font-size: 34px;
            color: #1a1a1a;
            padding-top: 6px;
            font-weight: 500;
            line-height: 48px;
        }
        .search {
            flex: 1;
            position: relative;
            .search-icon {
                position: absolute;
                left: 25px;
                bottom: 12px;
                width: 40px;
                height: 40px;
                background: url(../../../assets/img/b2b/search.png) no-repeat;
                background-size: 100% 100%;
            }
            input {
                height: 64px;
                line-height: 64px;
                border-radius: 200px;
                padding-left: 74px;
                font-size: 28px;
                color: #cccccc;
                background-color: #f5f5f5;
                box-sizing: border-box;
            }
        }
    }
    .contain {
        background: rgba(245, 245, 245, 1);
    }
    .couput {
        position: fixed;
        bottom: 200px;
        width: 160px;
        height: 160px;
        right: 24px;
    }
    .msk {
        opacity: 1;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
    }
    .mint-popup {
        border-radius: 16px;
        background: #ffffff;
    }
}
/deep/ .mint-swipe-indicator {
    width: 14px;
    height: 14px;
    margin: 10px;
}
/deep/ .mint-swipe-indicator.is-active {
    background: rgb(252, 74, 4);
}
/deep/ .van-tabs__nav {
    background: none;
}
/deep/ [class*="van-hairline"]::after {
    border: none;
}
/deep/ .van-tab {
    font-size: 26px;
    color: #999999;
    line-height: 60px;
    padding: 0 20px;
    opacity: 0.8;
}
/deep/ .van-tabs__line {
    background-color: #ff7a45;
    height: 4px;
    bottom: 4px;
}
/deep/ .van-tabs__nav--line {
    padding-bottom: 0;
}
/deep/ .van-tab--active {
    color: #ff7a45;
    font-size: 28px;
    font-weight: 500;
    opacity: 1;
}
/deep/ .van-tabs--line .van-tabs__wrap {
    height: 60px;
    background: #ffffff;
}
/deep/ .van-loading__text {
    font-size: 24px;
}
/deep/ .van-pull-refresh {
    overflow: inherit;
}
/deep/ .van-tabs__nav--complete {
    padding: 0 20px;
}
</style>
<style lang="scss">
// 解决预览问题
body::-webkit-scrollbar {
    display: none;
}
</style>
